import React, { useEffect, useState } from "react";
import { BellRing, Save } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { inputCls } from "./EaUi";
import { fmtSignedPct } from "./eaFormat";
import { errMsg, num, str } from "./eaFixUtil";

const LBL = { ALL: "Totale", POWER: "Power", GAS: "Gas" };

export function EaBudgetAlert({ year, params, v }) {
  const [d, setD] = useState(null);
  const [f, setF] = useState({ enabled: true, thr: "5" });
  const load = () => api.get("/ea/budget/alert", { params: { ...params, year } }).then((r) => { setD(r.data); setF({ enabled: r.data.settings.enabled, thr: str(r.data.settings.threshold_pct, 1) }); });
  useEffect(() => { load().catch(() => setD(null)); }, [year, params.company_id, v]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const save = async () => {
    const t = num(f.thr);
    if (t == null || Number.isNaN(t) || t < 0 || t > 100) return toast.error("Soglia non valida (0–100%)");
    try { const r = await api.put("/ea/budget/alert", { enabled: f.enabled, threshold_pct: t }, { params }); await load(); toast.success(r.data.sent?.length ? `Avviso inviato a ${r.data.sent.length} destinatari` : "Impostazioni avviso salvate"); }
    catch (e) { toast.error(errMsg(e, "Salvataggio non riuscito")); }
  };
  const last = d.last_alert;
  return (
    <div className="card-elevated p-5 space-y-3" data-testid="ea-budget-alert">
      <div className="flex items-center gap-2 font-display font-semibold text-slate-900"><BellRing size={16} className="text-red-600" /> Avviso budget via email</div>
      <div className="flex flex-wrap items-end gap-4">
        <label className="text-xs text-slate-600 inline-flex items-center gap-2 h-9"><input type="checkbox" checked={f.enabled} onChange={(e) => setF({ ...f, enabled: e.target.checked })} data-testid="ea-alert-enabled" /> Avviso attivo</label>
        <label className="text-xs text-slate-600">Soglia oltre il budget (%)<input value={f.thr} onChange={(e) => setF({ ...f, thr: e.target.value })} className={`${inputCls} w-28 mt-1 block`} data-testid="ea-alert-threshold" /></label>
        <button onClick={save} className="h-9 px-4 rounded-lg bg-slate-900 text-white text-sm font-semibold inline-flex items-center gap-2" data-testid="ea-alert-save"><Save size={15} /> Salva</button>
        <div className="flex flex-wrap gap-2" data-testid="ea-alert-state">
          {Object.entries(d.state).map(([k, s]) => (
            <span key={k} className={`px-2.5 py-1 rounded-full text-xs font-semibold ${s.over ? "bg-red-50 text-red-700" : "bg-green-50 text-green-700"}`} data-testid={`ea-alert-state-${k}`}>
              {LBL[k]}: {fmtSignedPct(s.delta_pct)} {s.over ? "· sopra soglia" : "· ok"}
            </span>
          ))}
        </div>
      </div>
      <div className="text-xs text-slate-500" data-testid="ea-alert-last">
        Confronto: Forecast Dinamico annuale vs budget dei punti con budget, per Power, Gas e totale. L'email parte ai referenti del cliente una sola volta quando il forecast supera la soglia; un nuovo avviso solo se rientra e la supera di nuovo. Controllo ogni giorno alle 9:15, ad ogni caricamento dei forward e ad ogni modifica dei fixing.
        {last && <> Ultimo avviso: {new Date(last.sent_at).toLocaleString("it-IT")} ({last.recipients.length ? last.recipients.join(", ") : "nessun destinatario con email attive"}).</>}
      </div>
    </div>
  );
}
